import React from 'react';
import {Component, Configuration, Container, LocalCache} from "puzzle";

const switchBack = '/switchUser/switchUserExit?';

class ImpersonateUserRibbon extends Component<any, any> {

  /**
   * Switch back impersonated user to original view
   */
  switchBack = () => {
    const {REST_SERVER} = Configuration.get();
    const { DOMAIN, PROTOCOL, PORT, NAME } = REST_SERVER;
    let aquaUrl;
    if (PORT) {
      aquaUrl = `${PROTOCOL}://${DOMAIN}:${PORT}/${NAME}`;
    } else {
      aquaUrl = `${PROTOCOL}://${DOMAIN}/${NAME}`;
    }
    window.location.href = `${aquaUrl}${switchBack}&callbackUrl=${window.location.href}`;
    LocalCache.remove(['impersonate'], 'sessionStorage');
  };


  render() {
    const { userName } = this.props;
    return (
      <Container
        alignItemsCenter
        displayFlex
        justifyContentCenter
        className={'pd-header-ribbon pd-impersonate-user-ribbon tp-font-size-sm'} >
        <span>
          {this.translate('ribbonText')}
        </span>
        <span className={'tp-text-semibold pd-user-name'}>{this.translate('userName', {userName: userName})}</span>
        <span
          className={'pd-ribbon-btn-link tp-text-bold tp-text-underline tp-pointable'}
          role={'button'}
          tabIndex={0}
          onClick={this.switchBack}
        >
          {this.translate('switchBack')}
        </span>
      </Container>
    );
  }
}

export default ImpersonateUserRibbon;
